import { normaliseMoney } from "../utils/moneyUtils";
import { ESTATE_ITEM_TYPES } from "./estateItemTypes";

const submission = (payload) => ({ submission_type: "probate_estate_item_added", payload });

const trimmed = (value) => value?.trim() || null;

const toPence = (value) => {
  const pounds = trimmed(value);
  return pounds == null ? null : Math.round(parseFloat(normaliseMoney(pounds)) * 100);
};

const withoutBlanks = (payload) => Object.fromEntries(Object.entries(payload).filter(([, value]) => value != null));

const institutionItem = (itemType, { name, reference }) => {
  const type = ESTATE_ITEM_TYPES[itemType];
  const institutionName = name.trim();
  const accountReference = type.lastFourDigitsOnly
    ? trimmed((reference ?? "").replace(/\D/g, "").slice(-4))
    : trimmed(reference);
  return withoutBlanks({
    item_type: itemType,
    description: `${institutionName} ${type.noun}`,
    account_reference: accountReference,
    institution: { name: institutionName, institution_type: type.institution },
  });
};

// The vehicle form asks about finance too. A finance agreement is a loan in the estate, so it goes
// as a second item rather than a field on the vehicle.
const vehicleItems = ({ description, finance, lender }) => {
  const vehicle = { item_type: "vehicle", description: description.trim() };
  if (finance !== "yes") return [vehicle];
  const lenderName = trimmed(lender);
  const loan = withoutBlanks({
    item_type: "loan",
    description: `Finance on ${vehicle.description}`,
    institution: lenderName && { name: lenderName, institution_type: "lender" },
  });
  return [vehicle, loan];
};

// The bodies for POST /api/dashboard/case/{caseID}/submission, in the order to send them. Each
// payload is ClientEstateItem in webapp-alpha, whose institution forbids any key but name and
// institution_type.
export const estateItemSubmissions = (itemType, values) => {
  switch (ESTATE_ITEM_TYPES[itemType].fields) {
    case "institution":
      return [submission(institutionItem(itemType, values))];
    case "vehicle":
      return vehicleItems(values).map(submission);
    default:
      return [
        submission(
          withoutBlanks({
            item_type: itemType,
            description: values.description.trim(),
            value_pence: toPence(values.value),
          }),
        ),
      ];
  }
};
